import { useEffect, useMemo, useRef, useState } from "react";

export default function PendingAnswer() {
  const phases = useMemo(
    () => [
      { t: 0, msg: "Pensando na melhor resposta…" },
    ],
    []
  );

  const startRef = useRef(Date.now());
  const [elapsed, setElapsed] = useState(0);
  const [msg, setMsg] = useState(phases[0].msg);

  useEffect(() => {
    const tick = () => {
      const s = Math.floor((Date.now() - startRef.current) / 1000);
      setElapsed(s);
      const current = [...phases].reverse().find((p) => s >= p.t) ?? phases[0];
      setMsg(current.msg);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [phases]);

  const formatTime = (seconds) => {
    if (seconds === 0) return null;
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    if (minutes > 0) {
      return `${minutes}m ${secs}s`;
    }
    return `${secs}s`;
  };

  return (
    <div className="ia-pending">
      <div className="ia-pending__line">
        <span className="ia-pending__msg">{msg}</span>
        <span className="ia-pending__elapsed">
          {formatTime(elapsed)}
        </span>
      </div>

      <div className="ia-typing" aria-label="Aguardando resposta da IA">
        <span className="ia-typing-dot" />
        <span className="ia-typing-dot" />
        <span className="ia-typing-dot" />
      </div>
    </div>
  );
}
